import React, { ReactNode } from "react";
import clsx from "clsx";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export type PersistentDrawerWrapperProps = {
  children: ReactNode;
  open: boolean;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginRight: 0,
    },
    contentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: 550,
    },
  })
);
export const PersistentDrawerWrapper: React.FC<PersistentDrawerWrapperProps> = ({
  children,
  open,
}) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.content, {
        [classes.contentShift]: open,
      })}
    >
      {children}
    </div>
  );
};
